import ConversionBar from 'components/Shared/ConversionBar';
import Breadcrumbs from 'components/ui/Breadcrumbs';
import ContentBlocks from 'components/ui/ContentBlocks';
import BlockLoaderNonFields from 'components/ui/ContentBlocks/BlockLoaderNonFields';
import type { FullWidthContentBlock } from 'types/PageData';
import type { ISpecialityPageFields } from 'types/contentful/generated';

type Props = {
  entry: ISpecialityPageFields;
  fullWidthBlocks: {
    top: FullWidthContentBlock | null;
    bottom: FullWidthContentBlock | null;
  };
  sidebar: boolean;
};

const SpecialityPage = ({
  entry,
  fullWidthBlocks,
  sidebar,
}: Props): JSX.Element => {
  const breadcrumbs = [
    {
      link: entry.slug,
      title: entry.specialityName || entry.title,
    },
  ];

  return (
    <>
      <div className="bg-secondary">
        <Breadcrumbs
          containerClassNames="hidden md:block"
          className="md:pb-12"
          crumbs={breadcrumbs}
        />
        <div className="max-w-screen-xl mx-auto px-5 md:px-4 py-8 md:pt-0 md:pb-8">
          <h1 className="text-3_5xl md:text-4_5xl text-primary leading-none pt-0">
            {entry.title}
          </h1>
        </div>
      </div>
      {fullWidthBlocks?.top && (
        <ContentBlocks
          type={fullWidthBlocks.top.__typename as string}
          fields={fullWidthBlocks.top}
          config={{ useH1: true }}
        />
      )}
      <div className="max-w-screen-xl mx-auto">
        <div className="md:grid md:grid-cols-3 md:gap-x-5">
          <div className="md:col-span-2">
            <div className="pt-8 pb-16">
              <div>
                {entry.blocks && (
                  <BlockLoaderNonFields entry={entry} field="blocks" />
                )}
              </div>
            </div>
          </div>
          {sidebar && <div>{sidebar}</div>}
        </div>
      </div>
      {fullWidthBlocks?.bottom && (
        <ContentBlocks
          type={fullWidthBlocks.bottom.__typename as string}
          fields={fullWidthBlocks.bottom}
        />
      )}
      <ConversionBar />
    </>
  );
};

export default SpecialityPage;
